"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.AppPanel = exports.getPanelClassNames = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _Styling = require("@fluentui/react/lib/Styling");

var _Button = require("@fluentui/react/lib/Button");

var _Panel = require("@fluentui/react/lib/components/Panel");

var React = _interopRequireWildcard(require("react"));

var _AppPanel = require("./AppPanel.classNames");

var getPanelClassNames = (0, _react.classNamesFunction)();
/**
 * AppPanel represents a panel that leaves the app bar still visible
 */

exports.getPanelClassNames = getPanelClassNames;

var AppPanel = /*#__PURE__*/function (_BaseComponent) {
  (0, _inherits2.default)(AppPanel, _BaseComponent);

  var _super = (0, _createSuper2.default)(AppPanel);

  function AppPanel() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, AppPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));

    _this.dismiss = function () {
      var _this$props$onDismiss, _this$props;

      (_this$props$onDismiss = (_this$props = _this.props).onDismiss) === null || _this$props$onDismiss === void 0 ? void 0 : _this$props$onDismiss.call(_this$props);
    };

    _this.onRenderNavigation = function () {
      return null;
    };

    _this._renderHeader = function (props, defaultRender) {
      var _ref = props !== null && props !== void 0 ? props : {},
          headerText = _ref.headerText,
          componentId = _ref.componentId,
          _ref$headerClassName = _ref.headerClassName,
          headerClassName = _ref$headerClassName === void 0 ? '' : _ref$headerClassName,
          styles = _ref.styles,
          _ref$theme = _ref.theme,
          theme = _ref$theme === void 0 ? (0, _Styling.getTheme)() : _ref$theme,
          closeButtonAriaLabel = _ref.closeButtonAriaLabel;

      var classNames = (0, _AppPanel.getClassNames)();
      var panelClassNames = getPanelClassNames(styles, {
        theme: theme
      });

      if (headerText) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: (0, _react.css)('ms-Panel-header', panelClassNames.header, classNames.header),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: (0, _react.css)('ms-Panel-headerText', panelClassNames.headerText, classNames.headerText, headerClassName),
            id: componentId + '-headerText',
            role: "heading",
            "aria-level": 1,
            children: headerText
          }), _this.props.hasCloseButton !== false ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.IconButton, {
            className: classNames.headerNavigation,
            iconProps: {
              iconName: 'Cancel'
            },
            onClick: _this.dismiss,
            ariaLabel: closeButtonAriaLabel
          }) : null]
        });
      }

      return null;
    };

    return _this;
  }

  (0, _createClass2.default)(AppPanel, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var classNames = (0, _AppPanel.getClassNames)(this.props.isContentFullBleed);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Panel.Panel, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.props), {}, {
        hasCloseButton: false,
        isLightDismiss: true,
        className: (0, _react.css)(classNames.root, this.props.className),
        onRenderHeader: this._renderHeader,
        onRenderNavigation: this.onRenderNavigation,
        children: children
      }));
    }
  }]);
  return AppPanel;
}(_react.BaseComponent);

exports.AppPanel = AppPanel;